import React from 'react';

import { callApi } from 'helpers/callApi/callApi';
import { SimpleModalId } from 'constants/modalId';
import AppModal from 'components/modal/appModal';
import { DeleteUserModalContentProps } from './DeleteUserModal.types';

export const DeleteUserModalContent = ({ deleteUser, closeModal, data }: DeleteUserModalContentProps) => {
  const handleSubmit = () => {
    callApi({
      action: () => deleteUser(data.id),
      onSuccess: () => {
        closeModal();
      },
    });
  };

  return (
    <AppModal
      id={SimpleModalId.DeleteUser}
      title="Delete user"
      hideOpenButton
      submitButtonLabel="Yes"
      submitAction={handleSubmit}
      closeButtonLabel="No"
      className="delete-modal"
    >
      <p>
        Are you sure you want to delete <strong>{data.email}</strong>?
      </p>
    </AppModal>
  );
};
